// Media URL helpers — detect YouTube / Facebook (reel, video, post, photo) vs. plain image.

/** Detect media type and produce embed metadata from any URL. */
export const parseMedia = (sourceUrl) => {
  if (!sourceUrl) return { type: "image", src: "", sourceUrl: "" };
  const url = String(sourceUrl).trim();

  // -------- YouTube --------
  const yt =
    url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/))([A-Za-z0-9_-]{6,})/) ||
    url.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/);
  if (yt) {
    const id = yt[1];
    return {
      type: "youtube",
      videoId: id,
      embedUrl: `https://www.youtube.com/embed/${id}?rel=0`,
      thumbnailUrl: `https://img.youtube.com/vi/${id}/hqdefault.jpg`,
      sourceUrl: url,
      aspect: "16/9",
      label: "YouTube",
    };
  }

  // -------- Facebook --------
  if (/(?:facebook\.com|fb\.watch)/i.test(url)) {
    const isReel = /\/reel\//i.test(url);
    const isVideo = isReel || /\/videos?\/|\/watch\/?\?v=|fb\.watch/i.test(url);
    const plugin = isVideo ? "video.php" : "post.php";
    return {
      type: "facebook",
      embedUrl: `https://www.facebook.com/plugins/${plugin}?href=${encodeURIComponent(url)}&show_text=false&width=auto`,
      sourceUrl: url,
      aspect: isReel ? "9/16" : isVideo ? "16/9" : "1/1",
      label: isReel ? "Facebook Reel" : isVideo ? "Facebook Video" : "Facebook Post",
    };
  }

  // -------- Default: image --------
  return { type: "image", src: url, sourceUrl: url, label: "Image" };
};

export const isVideoMedia = (sourceUrl) => {
  const t = parseMedia(sourceUrl).type;
  return t === "youtube" || t === "facebook";
};
